/**
 * SmartImprove → Client Output → Client Communication.
 *
 * Iter 91: Lightweight contextual launcher. The full editor lives at
 *   Platform → Shared Services → Email Templates  (/admin/email-templates)
 * — one source of truth across SmartEvaluate and SmartImprove. This
 * page just explains the SmartImprove-specific templates and deep-links
 * into the shared editor.
 */
import { Link } from "react-router-dom";
import { Mail, ExternalLink } from "lucide-react";

export default function ClientCommunicationPage() {
  return (
    <div className="space-y-5" data-testid="si-client-communication">
      <header>
        <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-[#025979]">
          SmartImprove · Client Output
        </p>
        <h1
          className="text-2xl font-bold text-[#111827] mt-1"
          style={{ fontFamily: "Chivo, sans-serif" }}
        >
          Client Communication
        </h1>
        <p className="text-sm text-[#6B7280] mt-1 max-w-2xl">
          Manage SmartImprove-specific communication templates used for:
        </p>
        <ul className="text-sm text-[#374151] mt-2 list-disc list-inside space-y-0.5">
          <li>Engagement submission confirmation</li>
          <li>Resume engagement reminder</li>
          <li>Finalized business case sharing</li>
        </ul>
        <p className="text-xs text-[#9CA3AF] mt-3 max-w-2xl">
          All templates live in the single shared editor — opening it here
          jumps you straight to the SmartImprove section.
        </p>
      </header>

      <section className="bg-white border border-[#E5E7EB] rounded-sm p-6 flex items-center justify-between">
        <div className="flex items-start gap-3">
          <Mail className="w-5 h-5 text-[#025979] mt-0.5" strokeWidth={1.5} />
          <div>
            <h2 className="text-sm font-semibold text-[#111827]">
              Manage email templates
            </h2>
            <p className="text-xs text-[#6B7280] mt-1 max-w-md">
              One shared template engine powers SmartEvaluate &amp; SmartImprove.
              Edits take effect immediately for future sends.
            </p>
          </div>
        </div>
        <Link
          to="/admin/email-templates"
          className="inline-flex items-center gap-1.5 px-3 py-2 text-xs font-semibold rounded-sm border border-[#025979] text-[#025979] hover:bg-[#025979] hover:text-white transition-colors"
          data-testid="si-client-communication-open-shared"
        >
          Open Shared Email Templates <ExternalLink className="w-3.5 h-3.5" />
        </Link>
      </section>
    </div>
  );
}
